// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as NextRecaptchaV3 from "next-recaptcha-v3";
import * as MediaQuery$PorterinUtils from "../../../../../../../../node_modules/@porterin/utils/src/hooks/MediaQuery.mjs";
import * as CityContext$PorterinFeature from "../../../../../contexts/city-context/CityContext.mjs";
import * as AddressContext$PorterinFeature from "../../../../../contexts/address-context/AddressContext.mjs";
import * as RecaptchaContext$PorterinFeature from "../../../../../contexts/recpatcha-context/RecaptchaContext.mjs";
import * as FareEstimateV2Helper$PorterinFeature from "../../../domain/helpers/FareEstimateV2Helper.mjs";
import * as FareEstimateContextV1$PorterinFeature from "../../../../../contexts/fare-estimate-context/FareEstimateContextV1.mjs";
import * as EditBookingDetailsState$PorterinFeature from "../form/EditBookingDetailsState.mjs";
import * as FareEstimateResultStateV1$PorterinFeature from "./FareEstimateResultStateV1.mjs";
import * as EditBookingDetailsInterface$PorterinFeature from "../form/EditBookingDetailsInterface.mjs";
import * as EditBookingDetailsDesktopCmp$PorterinFeature from "./EditBookingDetailsDesktopCmp.mjs";
import * as FareEstimateResultFormInterfaceV1$PorterinFeature from "../../../../../shared/lead-flow/view/component/result-form/FareEstimateResultFormInterfaceV1.mjs";

function EditBookingDetailsDesktopWrapperCmp(Props) {
  var close_modal = Props.close_modal;
  var waypoint = Props.waypoint;
  var match = AddressContext$PorterinFeature.useAddressContext(undefined);
  var receiver = match.receiver;
  var sender = match.sender;
  var match$1 = React.useState(function () {
        return EditBookingDetailsState$PorterinFeature.initialFormState(waypoint === /* Pickup */0 ? sender : receiver);
      });
  var setInitialInput = match$1[1];
  var match$2 = React.useState(function () {
        
      });
  var setPreviousResponse = match$2[1];
  var match$3 = FareEstimateContextV1$PorterinFeature.useFareEstimateContext(undefined);
  var query_params = match$3.query_params;
  var match$4 = AddressContext$PorterinFeature.useAddressContext(undefined);
  var set_is_serviceable_dropoff = match$4.set_is_serviceable_dropoff;
  var set_is_serviceable_pickup = match$4.set_is_serviceable_pickup;
  var recaptchaContext = RecaptchaContext$PorterinFeature.useRecaptchaContext(undefined);
  var citySelectedContext = CityContext$PorterinFeature.useCitySelectedContext(undefined);
  var recaptchaExecute = NextRecaptchaV3.useReCaptcha();
  var isMobile = MediaQuery$PorterinUtils.isMobile(undefined);
  var initialAddressInput = FareEstimateResultStateV1$PorterinFeature.initialFormState(query_params);
  var fareEstimateForm = FareEstimateResultFormInterfaceV1$PorterinFeature.Form.useForm(initialAddressInput, (function (output, callbacks) {
          Curry._1(set_is_serviceable_dropoff, true);
          Curry._1(set_is_serviceable_pickup, true);
          FareEstimateResultStateV1$PorterinFeature.onFormSubmit(set_is_serviceable_dropoff, set_is_serviceable_pickup, output, callbacks, query_params, recaptchaExecute, setPreviousResponse, citySelectedContext.category, isMobile, recaptchaContext, true);
          Curry._1(close_modal, undefined);
        }));
  var updateFareEstimatePickupDrop = function (address) {
    if (waypoint) {
      return Curry._2(fareEstimateForm.updateDrop_address, (function (input, value) {
                    return {
                            pickup_address: input.pickup_address,
                            drop_address: value,
                            category: input.category
                          };
                  }), address);
    } else {
      return Curry._2(fareEstimateForm.updatePickup_address, (function (input, value) {
                    return {
                            pickup_address: value,
                            drop_address: input.drop_address,
                            category: input.category
                          };
                  }), address);
    }
  };
  var form = EditBookingDetailsInterface$PorterinFeature.Form.useForm(match$1[0], (function (output, _callbacks) {
          FareEstimateV2Helper$PorterinFeature.setBookingDetailsInStorage(output, waypoint);
          Curry._1(fareEstimateForm.submit, undefined);
        }));
  React.useEffect((function () {
          var match = form.status;
          var exit = 0;
          if (typeof match === "number") {
            if (match !== /* Editing */0) {
              exit = 1;
            }
            
          } else if (match.TAG !== /* Submitting */0) {
            exit = 1;
          }
          if (exit === 1) {
            Curry._1(setInitialInput, (function (param) {
                    return form.input;
                  }));
            Curry._1(form.reset, undefined);
          }
          
        }), [form.status]);
  return React.createElement(EditBookingDetailsDesktopCmp$PorterinFeature.make, {
              waypoint: waypoint,
              close_modal: close_modal,
              booking_details_form: form,
              address_form: fareEstimateForm,
              address_on_change: updateFareEstimatePickupDrop,
              response: match$2[0]
            });
}

var make = EditBookingDetailsDesktopWrapperCmp;

export {
  make ,
}
/* react Not a pure module */
